import styled from 'styled-components';

import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { NoSSR } from '@xing-com/crate-utils-no-ssr';
import { spaceXXL } from '@xing-com/tokens';

import { useDisplayAds } from '../../use-display-ads';

const StyledFrame = styled.iframe`
  width: 728px;
  height: 90px;
  border: 0;
  margin: ${spaceXXL};
`;

export const DisplayAdLoginLeaderboardIframeSlot: React.FC = () => {
  const { displayAdsAllowed } = useDisplayAds();

  const isBigScreen = useMatchMedia(
    '(min-width: 1584px) and (min-height: 900px)'
  );

  if (!displayAdsAllowed || !isBigScreen) {
    return null;
  }

  return (
    <NoSSR>
      <StyledFrame
        src="/reklame/iframe"
        title="Reklame frame"
        sandbox="allow-scripts allow-same-origin allow-popups"
        scrolling="no"
      />
    </NoSSR>
  );
};
